module.exports = {
  translations: {
    // metamask
    'metamask.pleaseInstallFirst': 'Please install MetaMask first!',
    'metamask.youNeedSignMessage': 'You need to sign the message to be able to use system!',
    // award
    'award.pleaseSignIn': 'あなたのプレゼントを受け取るために、ログインしてください。',
    'award.signInUsingTwitter': 'Twitterアカウントでログイン',
    'award.congratulation': 'おめでとうございます!',
    'award.openLinkBelow': 'スマートフォンから下記URLをタップして抽選券をお受け取り下さい',
    'award.gotoTheLottery': '専用アプリから抽選会場へ行き、お好きな商品のくじをお楽しみください。',
    'award.termOf': 'ツイッターキャンペーンの規約',
    'award.sorry': '申し訳ありません!',
    'award.campaignHasEnded': '要求条件を満たしていないかキャンペーンの期限が切れています。',
    'award.pleaseOpenTheWebsite': 'Please open the website on Chrome or Safari browser',
    'award.notice': 'Notice',
    'award.pleaseAllowPopup': 'Please allow popup to sign in.',
    'award.details': 'Details',
    'award.installTheApp': '1. アプリをインストール',
    'award.signInTwitter': '2. ツイッターにサインイン',
    'award.specializedAppRequiredToReceive': 'よしもとデジタルコレカ抽選券の受け取りには\n専用アプリが必要です',
    'award.afterInstallingTheApp': 'アプリをインストール後ツイッターにサインイン\nしてください',
    'award.tapTheUrl': '受け取りURLをタップして抽選券をお受け取りください',
    'award.caseYouCanNotSignIn': 'お申し込みが集中し、ログインできないような場合は、しばらく経ってから、\nもう一度お試し頂けるようお願い申し上げます',
    'award.copied': 'リンクをコピーしました',
    'award.serverBusy': 'サーバエラー',
    'award.theServerIsCurrentlyBusy': 'サーバーのエラーが発生しましたので、今回の要求を処理できません。\nしばらく経ってから、もう一度お試し頂けるようお願い申し上げます。',
    'award.argeeTheTerms': 'キャンペーンに参加すると利用規約\nに同意したものとします',
    // footer
    'footer.policy': 'プライバシーポリシー',
    'footer.terms': '利用規約',
    'footer.commercial': '特定商取引法の記載',
    'footer.paymentServices': '資金決済法に基づく表示'
  }
}